import { useState, useEffect, useCallback } from "react";
import THEME from "../../../theme";
import { finanzenApi } from "../services/finanzenApi";
import ZeitraumFilter, { zeitraumFuerPreset } from "../components/ZeitraumFilter";
import KpiKarten from "../components/KpiKarten";
import GewinnChart from "../components/GewinnChart";
import VergleichsTabelle from "../components/VergleichsTabelle";
import GroessteVeraenderungen from "../components/GroessteVeraenderungen";
import KategorienUebersicht from "../components/KategorienUebersicht";
import OffeneAufgaben from "../components/OffeneAufgaben";
import WiederkehrendeKosten from "../components/WiederkehrendeKosten";
import MonatsTabelle from "../components/MonatsTabelle";

export default function FinanzUebersichtSeite({ benutzerId, onNavigiere }) {
  const [preset, setPreset] = useState("dieser_monat");
  const [{ von, bis }, setZeitraum] = useState(zeitraumFuerPreset("dieser_monat"));
  const [daten, setDaten] = useState(null);
  const [aufgaben, setAufgaben] = useState([]);
  const [wiederkehrend, setWiederkehrend] = useState([]);
  const [fehler, setFehler] = useState("");

  const presetWechsel = (neu) => {
    setPreset(neu);
    if (neu !== "eigen") setZeitraum(zeitraumFuerPreset(neu));
  };

  const laden = useCallback(async () => {
    setFehler("");
    try {
      const [uebersicht, aufgabenDaten, wiederkehrendDaten] = await Promise.all([
        finanzenApi.uebersicht(benutzerId, { von, bis }),
        finanzenApi.aufgaben(benutzerId),
        finanzenApi.wiederkehrendeZahlungenListe(benutzerId),
      ]);
      setDaten(uebersicht);
      setAufgaben(aufgabenDaten.aufgaben);
      setWiederkehrend(wiederkehrendDaten);
    } catch (e) {
      setFehler(e.message);
    }
  }, [benutzerId, von, bis]);

  useEffect(() => { laden(); }, [laden]);

  return (
    <div>
      <ZeitraumFilter
        preset={preset} onPresetWechsel={presetWechsel}
        von={von} bis={bis}
        onVonChange={v => setZeitraum(z => ({ ...z, von: v }))}
        onBisChange={b => setZeitraum(z => ({ ...z, bis: b }))}
      />

      {fehler && <p style={{ color: THEME.colors.danger }}>{fehler}</p>}

      {daten && (
        <>
          <KpiKarten aktuellePeriode={daten.aktuelle_periode} vormonat={daten.vormonat} />
          <OffeneAufgaben aufgaben={aufgaben} onNavigiere={onNavigiere} />
          <GewinnChart monatsentwicklung={daten.monatsentwicklung} />
          <VergleichsTabelle aktuellePeriode={daten.aktuelle_periode} vormonat={daten.vormonat} />
          <GroessteVeraenderungen steigendeKosten={daten.steigende_kosten} sinkendeEinnahmen={daten.sinkende_einnahmen} />
          <KategorienUebersicht einnahmenNachKategorie={daten.aktuelle_periode.einnahmen_nach_kategorie} ausgabenNachKategorie={daten.aktuelle_periode.ausgaben_nach_kategorie} />
          <WiederkehrendeKosten zahlungen={wiederkehrend} />
          <MonatsTabelle monatsentwicklung={daten.monatsentwicklung} />
          <p style={{ color: THEME.colors.textMuted, fontSize: THEME.fontSize.sm, fontStyle: "italic" }}>{daten.hinweis}</p>
        </>
      )}
    </div>
  );
}
